import { FormLabel, Grid, TextField } from "@mui/material";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useWorkshopStore } from "../../../hooks/useWorkshopStore";
import { Workshop } from "../../../types/slices/workshopsType";

export const CreateEditWorkshopModal: React.FC<any> = (): JSX.Element | any => {
  const {
    editWorkshop,
    openModal,
    setOpenModal,
    isEdit,
    createWorkshopStore,
    editWorkshopStore,
    getWorkshops,
  } = useWorkshopStore();

  const [data, setData] = useState<Workshop>({
    name: "",
    code: "",
    n_academic_hours: 0,
  });

  const validateForm = (values) => {
    let errors: any = {};
    if (!values.name) errors.name = "Nombre es requerido";
    if (values.name && values.name.length > 200)
      errors.name = "El número máximo de caracteres es 200";
    if (!values.code) errors.code = "Código es requerido";
    if (values.code && values.code.length > 10)
      errors.code = "El número máximo de caracteres es 10";

    return errors;
  };

  const onSubmit = async (values) => {
    setOpenModal(false);
    const method = isEdit
      ? editWorkshopStore(editWorkshop?.id || 0, values)
      : createWorkshopStore(values);
    const response = await method;
    if (response === true) {
      getWorkshops();
    }
  };

  useEffect(() => {
    if (isEdit) {
      setData(editWorkshop);
    } else {
      setData({
        name: "",
        code: "",
        n_academic_hours: 0,
      });
    }
  }, [isEdit, editWorkshop]);

  return (
    <>
      <Modal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        disableEscapeKeyDown
        disableBackdropClick
        size="sm"
      >
        <ModalHeader
          text={isEdit ? "Editar Taller" : "Crear Taller"}
          className="positionElements"
          onCancel={() => setOpenModal(false)}
          // clearState={clearEditStudent}
        ></ModalHeader>

        <Formik
          initialValues={data}
          enableReinitialize
          validate={(values) => validateForm(values)}
          onSubmit={onSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            handleChange,
            setFieldValue,
          }) => {
            return (
              <>
                <ModalBody>
                  <form onSubmit={handleSubmit}>
                    <Grid container>
                      <Grid item container xs={12} spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12}>
                          <FormLabel>Nombre:</FormLabel>
                          <TextField
                            id="name"
                            type="text"
                            name="name"
                            fullWidth
                            size="small"
                            value={values.name}
                            onChange={handleChange}
                            error={errors.name && touched.name ? true : false}
                            helperText={
                              errors.name && touched.name ? errors.name : ""
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FormLabel>Código:</FormLabel>
                          <TextField
                            id="code"
                            type="text"
                            name="code"
                            fullWidth
                            size="small"
                            value={values.code}
                            onChange={handleChange}
                            error={errors.code && touched.code ? true : false}
                            helperText={
                              errors.code && touched.code ? errors.code : ""
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FormLabel>N° Horas académicas:</FormLabel>
                          <TextField
                            id="n_academic_hours"
                            type="number"
                            name="n_academic_hours"
                            fullWidth
                            size="small"
                            value={values.n_academic_hours}
                            onChange={handleChange}
                            error={
                              errors.n_academic_hours &&
                              touched.n_academic_hours
                                ? true
                                : false
                            }
                            helperText={
                              errors.n_academic_hours &&
                              touched.n_academic_hours
                                ? errors.n_academic_hours
                                : ""
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </ModalBody>
                <ModalFooter
                  confirmText={isEdit ? "Actualizar" : "Registrar"}
                  onConfirm={handleSubmit}
                  cancelText={"Cancelar"}
                  onCancel={() => {
                    setOpenModal(false);
                  }}
                  className="modal-confirm-footer"
                  // loadingConfirmText={status2}
                />
              </>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};
